import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cc-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
